export enum BidMode {
  _null = 0,  //a fake element here makes my enums match the Feza DB look up table.
  Learning = 1,
  Precommissioning = 2,
  Postcommissioning = 3,
  Infield = 4
}

export const BidModeList = [
  {name:null},//fake element here to make the index match the enum, so we can look up by id to get the name
  { name: "Learning", mode: BidMode.Learning, disabled: false },
  { name: "PreCommissioning", mode: BidMode.Precommissioning, disabled: false},
  { name: "PostCommissioning", mode: BidMode.Postcommissioning, disabled: false},
  { name: "InField", mode: BidMode.Infield, disabled: true},
];




// WEBPACK FOOTER //
// ./src/app/enums/bid-mode.enum.ts